import { ReactElement, ReactNode } from "react";

import { GenericExperienceFe } from "@intelligems/ig-types";
import { useCanStartExperience } from "@src/components/LimitAccess/experiment-scope-hooks";
import { ScopedComponentWithDisable } from "@src/components/LimitAccess/ScopedComponentWithDisable";

interface ScopedStartExperienceWithDisabledProps {
  experience: GenericExperienceFe;
  debugId: string;
  adminDisable?: boolean;
  customDisabledTooltipMessage?: ReactNode;
  customEnabledTooltipMessage?: ReactNode;
  additionalEnableRequirements?: boolean[];
  children: ReactElement<{
    disabled: boolean;
    onClick?: () => void;
    onChange?: () => void;
  }>;
}

export const ScopedStartExperienceWithDisabled = ({
  experience,
  adminDisable,
  children,
  customDisabledTooltipMessage,
  debugId,
  additionalEnableRequirements,
  customEnabledTooltipMessage,
}: ScopedStartExperienceWithDisabledProps) => {
  const { canStart, disabledMessage } = useCanStartExperience(experience);

  return (
    <ScopedComponentWithDisable
      debugId={debugId}
      adminDisable={adminDisable}
      customDisabledTooltipMessage={
        customDisabledTooltipMessage || disabledMessage
      }
      isEnabled={Boolean(
        experience.status === "started" ||
        (canStart &&
          (additionalEnableRequirements?.length
            ? additionalEnableRequirements.every((r) => !!r)
            : true))
      )}
      customEnabledTooltipMessage={customEnabledTooltipMessage}
    >
      {children}
    </ScopedComponentWithDisable>
  );
};
